import { Inject, Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CompanyGroup, CompanyGroupApi } from './company-group';
import { API_BASE_URL_SERVICE } from '../../../../projects/kiene-core/src/lib/kiene-core.config';
import { KieneBackendApiService } from '../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import {
    PdfViewerDesktopService,
    PdfViewerDialogInput,
} from '../../../../projects/kiene-core/src/lib/components/pdf-viewer/kiene-pdf-viewer/kiene-pdf-viewer-desktop/pdf-viewer-desktop.service';
import { FileDownloadService } from '../../services/file-download.service';

@Injectable({ providedIn: 'root' })
export class CompanyGroupService {
    constructor(
        @Inject(API_BASE_URL_SERVICE) private readonly apiBaseUrl,
        private readonly pdfService: PdfViewerDesktopService,
        private readonly api: KieneBackendApiService,
        private readonly fileDownloadService: FileDownloadService,
    ) {}

    openPreislistePdf(unternehmensgruppe_id: number, verkaufspreis_id: number) {
        this.pdfService.openPdfViewer(
            new PdfViewerDialogInput(
                'unternehmensgruppe/read_pdf_preisliste.php',
                new HttpParams()
                    .set('unternehmensgruppe_id', unternehmensgruppe_id?.toString())
                    .set('verkaufspreis_id', verkaufspreis_id?.toString()),
                'Preisliste',
            ),
        );
    }

    downloadPreislisteExcel(unternehmensgruppe_id: number, verkaufspreis_id: number) {
        const params = new HttpParams()
            .set('unternehmensgruppe_id', unternehmensgruppe_id)
            .set('verkaufspreis_id', verkaufspreis_id);
        const url = 'unternehmensgruppe/read_excel_preisliste.php';
        this.fileDownloadService.downloadExcel(url, params);
    }

    getVerkaufspreise() {
        return this.api.getAll(this.apiBaseUrl + 'verkaufspreis/read.php', null);
    }

    searchCompanyGroups(searchString: string): Observable<CompanyGroupApi> {
        let params = new HttpParams().append('limit', '25').append('offset', '0');
        if (searchString) {
            params = params.append('search', searchString);
        }
        return this.api.getAll(this.apiBaseUrl + 'unternehmensgruppe/read.php', params);
    }

    getCompanyGroup(id: string): Observable<CompanyGroup> {
        return this.api.getByIdAlternative(
            this.apiBaseUrl + 'unternehmensgruppe/read_one.php',
            'unternehmensgruppe_id',
            id,
        );
    }

    saveCompanyGroup(companyGroup: CompanyGroup): Observable<CompanyGroup> {
        return this.api.updateGeneric(this.apiBaseUrl + 'unternehmensgruppe/update.php', companyGroup);
    }

    deleteCompanyGroup(companyGroup: CompanyGroup): Observable<CompanyGroup> {
        return this.api.deleteGeneric(this.apiBaseUrl + 'unternehmensgruppe/delete.php', companyGroup);
    }
}
